<template>
  <div>
    <FormAutocomplete
      :label="label"
      :placeholder="placeholder"
      :dense="dense"
      :solo="solo"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
      :hide-selected="false"
      :items-filter="menuItemsFilter"
      :chips="multiple"
      :validation="validation"
      :multiple="multiple"
      :options="options"
      :loading="loading"
      search-on-first-interaction
      @search="onSearch"
      @change="onChange"
      v-model="selected"
      useTemplate
      return-object
    >
      <template v-slot:item="{ item }">
        <slot name="item" :item="item">
          {{ item.text }}
        </slot>
      </template>
    </FormAutocomplete>
    <section class="mb-8" v-if="order">
      <h3>Arraste para ordenar as tags</h3>
      <draggable v-model="selected" @start="drag = true" @end="onEnd">
        <transition-group
          type="transition"
          name="flip-list"
          class="containerListProduct"
        >
          <div
            class="containerSort"
            v-for="item in selected"
            :key="item.idtagpesquisa"
            :id="item.idtagpesquisa"
          >
            <div class="sortable">
              {{ item.text }}
            </div>
          </div>
        </transition-group>
      </draggable>
    </section>
  </div>
</template>

<script>
import FormAutocomplete from "@/components/form/FormAutocomplete";
import ApiWeb from "../../service/api-web";
import * as _ from "lodash";
import draggable from "vuedraggable";

export default {
  name: "FormTag",
  components: { FormAutocomplete, draggable },
  props: {
    value: {
      type: [Array, Object],
      default: () => [],
      required: false
    },
    label: {
      type: String,
      default: "",
      required: false
    },
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    dense: {
      type: Boolean,
      default: true,
      required: false
    },
    solo: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    clearable: {
      type: Boolean,
      default: false,
      required: false
    },
    endpoint: {
      type: String,
      required: true
    },
    keyid: {
      type: String,
      default: "id",
      required: false
    },
    keyvalue: {
      type: String,
      default: "name",
      required: false
    },
    queryname: {
      type: String,
      default: "search",
      required: false
    },
    multiple: {
      type: Boolean,
      default: true,
      required: false
    },
    searchWithSpaces: {
      type: Boolean,
      default: false,
      required: false
    },
    validation: {
      type: Object,
      default: () => null,
      required: false
    },
    order: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    loading: false,
    lookupCache: [],
    dropdownItems: [],
    selected: []
  }),
  computed: {
    options() {
      const byId = new Map();
      const mergeItem = item => {
        const id = _.get(item, this.keyid);
        if (!id) return;
        const cached = _.find(this.lookupCache, [this.keyid, id]);
        byId.set(id, { ...(byId.get(id) || {}), ...(cached || {}), ...item });
      };

      const selectedList =
        this.multiple && Array.isArray(this.selected)
          ? this.selected
          : this.selected && !Array.isArray(this.selected)
          ? [this.selected]
          : [];
      selectedList.forEach(mergeItem);
      (this.dropdownItems || []).forEach(mergeItem);

      const sortKey = item =>
        String(item[this.keyvalue] ?? item.text ?? "").trim();

      return [...byId.values()]
        .map(item => this.mapResultItem(item))
        .sort((a, b) =>
          sortKey(a).localeCompare(sortKey(b), "pt-BR", {
            sensitivity: "base"
          })
        );
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;

        if (!this.multiple) {
          const newId = _.get(newVal, this.keyid);
          const oldId = _.get(oldVal, this.keyid);
          if (newId && newId === oldId) return;
        }

        this.initModel(newVal);
      }
    }
  },
  created() {
    this.initModel(this.value);
    if (this.searchWithSpaces === null) {
      this.searchWithSpaces = true;
    }
  },
  methods: {
    initModel(value) {
      if (value) {
        if (Array.isArray(value)) {
          this.selected = (value || []).map(item => ({
            ...item,
            text: item[this.keyvalue],
            value: item[this.keyid]
          }));
        } else {
          this.selected = this.mapResultItem(value);
          const tagId = _.get(this.selected, this.keyid);
          if (tagId && !_.find(this.lookupCache, [this.keyid, tagId])) {
            this.lookupCache = [this.selected].concat(this.lookupCache);
          }
        }
      }
      this.onChangeExternalValue();
    },
    onChangeExternalValue() {
      const itemsSelected = Array.isArray(this.selected)
        ? this.selected
        : [this.selected];
      const idtags = _.uniq(
        itemsSelected.reduce((tags, tag) => {
          const tagId = _.get(tag, this.keyid);
          if (tagId) {
            tags.push(tagId);
          }
          return tags;
        }, [])
      );
      if (idtags.length > 0) {
        const chunks = _.chunk(idtags, 50);
        for (let i in chunks) {
          const chunk = chunks[i];
          this.onSearch(chunk, true);
        }
      }
    },
    mapResultItem(item) {
      return {
        ...item,
        text: item[this.keyvalue],
        value: item[this.keyid]
      };
    },
    menuItemsFilter(item) {
      const id = _.get(item, this.keyid);
      if (!id) return false;
      return (this.dropdownItems || []).some(
        dropdownItem => _.get(dropdownItem, this.keyid) === id
      );
    },
    findInCaches(tagId) {
      return (
        _.find(this.lookupCache, [this.keyid, tagId]) ||
        _.find(this.dropdownItems, [this.keyid, tagId])
      );
    },
    syncSelectedWithResults() {
      if (this.multiple) {
        if (!Array.isArray(this.selected)) return;

        this.selected = this.selected.map(tag => {
          const tagId = _.get(tag, this.keyid);
          const match = this.findInCaches(tagId);
          return match ? this.mapResultItem(match) : tag;
        });
        return;
      }

      if (!this.selected || Array.isArray(this.selected)) return;

      const tagId = _.get(this.selected, this.keyid);
      if (!tagId) return;

      const match = this.findInCaches(tagId);
      if (match) {
        const mapped = this.mapResultItem(match);
        const selectedId = _.get(this.selected, this.keyid);
        const textChanged = this.selected?.text !== mapped.text;
        this.selected = mapped;
        if (textChanged || selectedId !== mapped[this.keyid]) {
          this.onChange(this.selected);
        }
      }
    },
    onSearch(value, isIdLookup = false) {
      this.loading = true;
      const arrayValues = Array.isArray(value) ? value : [value];
      const idLookup = isIdLookup || Array.isArray(value);
      const initialQuery = this.endpoint.split("?");
      const queryParms = arrayValues.reduce((query, val) => {
        if (query) query += "&";
        query += `${this.queryname}=${val}`;
        return query;
      }, _.get(initialQuery, "1", ""));
      ApiWeb.api
        .get(`${initialQuery[0]}?${queryParms}`)
        .then(resp => {
          const data = resp.data || [];
          if (idLookup) {
            this.lookupCache = _.uniqBy(
              this.lookupCache.concat(data),
              this.keyid
            );
          } else {
            // Busca remota substitui a lista da dropdown (no-filter=true no autocomplete)
            this.dropdownItems = data;
          }
          this.syncSelectedWithResults();
        })
        .finally(() => (this.loading = false));
    },
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
    onEnd() {
      this.selected = this.selected.map((item, i) => ({
        ...item,
        ordem: i + 1,
        text: item[this.keyvalue],
        value: item[this.keyid]
      }));
      this.initModel(this.selected);
      this.onChange(this.selected);
    }
  }
};
</script>

<style lang="scss">
.containerListProduct {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}

.containerSort {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  border-radius: 30px;
  border: 1px solid #ccc;

  .sortable {
    text-align: center;
    width: 100%;
    padding: 0.7em;
    cursor: move;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}
</style>
